import { render, staticRenderFns } from "./GrocersSettings.vue?vue&type=template&id=11452a4e&scoped=true"
import script from "./GrocersSettings.vue?vue&type=script&lang=js"
export * from "./GrocersSettings.vue?vue&type=script&lang=js"
import style0 from "./GrocersSettings.vue?vue&type=style&index=0&id=11452a4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11452a4e",
  null
  
)

export default component.exports